var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("ocean-bi::sc-analysis::edit-returnRate"),
        width: "500px",
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.form, "label-width": "55px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("ocean-bi::sc-analysis::退货率") } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t(
                    "ocean-bi::sc-analysis::returnRate-holder"
                  ),
                },
                model: {
                  value: _vm.form.rate,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "rate", $$v)
                  },
                  expression: "form.rate",
                },
              }),
            ],
            1
          ),
          _c("p", { staticClass: "tips" }, [
            _vm._v(_vm._s(_vm.$t("ocean-bi::sc-analysis::returnRate-tips"))),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }